<h1 class="page-title">Email Preferences</h1>
<form *ngIf="!submitted" [formGroup]="profileForm" (ngSubmit)="onSubmit(profileForm.value)">
	<div class="field-message-section">
		<div class="field">
			<div class="field__label-input-wrap">
				<label for="email" class="label">Email</label>
				{{email}}
				<div *ngIf="formErrors.email" class="error-message field__error-message">{{ formErrors.email }}</div>
			</div>
		</div>
		<h2 style="margin-top: 10px;">Communications Preference</h2>
		<div class="field">Please select the communication you wish to opt-out of.</div>
		<div class="divAsRow">
			<div class="divAsColumn">
				<p><u><strong>Email</strong></u></p>
				<p>	<input class="" id="emailOptOut" formControlName="emailOptOutCredExp" type="checkbox"> Credential Expiration</p>
				<p>	<input class="" id="emailOptOut" formControlName="emailOptOutCMPAssessment" type="checkbox"> CMP Assessments</p>
				<p>	<input class="" id="emailOptOut" formControlName="emailOptOutAnnual" type="checkbox"> Annual Payments</p>
				<p>	<input class="" id="emailOptOut" formControlName="emailOptOutMarket" type="checkbox"> Marketing and Promotions</p>				
				<p>	<input class="" id="emailOptOut" formControlName="emailOptOutResearch" type="checkbox"> Research Studies</p>		
				<p>	<input class="" id="emailOptOut" formControlName="emailOptOut" type="checkbox"> All Email*</p>
				<p style="font:smaller">*We will only contact you about policy adjustments.</p>
			</div>
		</div>
		<div *ngIf="!validFormCheck"  class="error-message">
			<div class="form-row">	
				<p>Fix errors indicated above to continue.</p>
			</div>	
		</div>
	</div>
	<div class="form-actions">
		<input class="button form-actions__item" type="submit" value="Save" />
		<button (click)="cancel($event)" class="button button--secondary form-actions__item">Cancel</button>
	</div>
</form>
<div *ngIf="submitted">
	Your email preferences have been updated. You can always login at <a href="practitionerportal.nbrc.org">nbrc.org</a> to update your preferences.
</div>